import { isMobileBreakpoint, isLocalUrl } from '../utils';

export default function cardsWidget() {
  const widgetName = 'cardsWidget';
  const widgetOpts = cardsWidgetOpts;

  const wrapContainerClass = 'cards-section';
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: isMobileBreakpoint ? ['all'] : [],
    showDescription: true,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    textOverImage: true,
    moreButton: false,
    maxItemsVisible: 8,
    itemsPerPanel: 1,
    buyNowButton: true,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomCards(data.items);
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });

  function createCustomCards(widgetData) {
    $widget.find('.card-widget-item').each(function (x) {
      const { Title, Description, URL } = widgetData[x];
      let urlAttribute = isLocalUrl(URL) ? '' : 'target="_blank"';

      const $cardItem = $(this);
      $cardItem.find('.card-content').remove();
      $cardItem.find('.image-container').append(`
          <div class="card-content">
            <div class="hover-content">
              ${Description ? `<p class="widget-description">${Description}</p>` : ''}
              ${URL ? `<a href="${URL}" class="button" ${urlAttribute}>More</a>` : ''}
            </div>
          </div>`);
      $cardItem.append(`<div class="card-title">${Title}</div>`);

      if (isLocalUrl(URL)) {
        $cardItem.removeAttr('target');
      }

      if (!URL && !Description) {
        $cardItem.addClass('empty-card').removeAttr('href');
      } else if (!URL && Description) {
        $cardItem.addClass('just-desc').removeAttr('href');
      } else if (URL && !Description) {
        $cardItem.addClass('only-url');
      }
    });
  }
}
